/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-resource-popup.vue?vue&type=template&id=db0e0428&scoped=true&"
import script from "./edit-resource-popup.vue?vue&type=script&lang=js&"
export * from "./edit-resource-popup.vue?vue&type=script&lang=js&"
import style0 from "./edit-resource-popup.vue?vue&type=style&index=0&id=db0e0428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0e0428",
  null
  
)

export default component.exports